/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

export interface MileagePreview {
  oneWayKm: number;
  totalKm: number;
  // centesimi di euro
  amount: number;
}

// Stessa regola di NoteSpese e dell'app (mobile/lib/services/expense_calc.dart):
// andata arrotondata a 0,1 km a metà in su, ritorno = doppio dell'andata
// arrotondata, importo in centesimi = (decimi * decimillesimi + 500) div 1000.
// Il server resta l'autorità: questa è solo un'anteprima.
export const mileagePreview = (
  oneWayKm: number,
  ratePerKm: number,
  roundTrip: boolean,
): MileagePreview => {
  if (!Number.isFinite(oneWayKm) || !Number.isFinite(ratePerKm)) {
    return {oneWayKm: 0, totalKm: 0, amount: 0};
  }
  // Passando dai centesimi: 27.45 * 10 vale 274.4999... in virgola mobile.
  const oneWayTenths = Math.max(
    0,
    Math.floor((Math.round(oneWayKm * 100) + 5) / 10),
  );
  const tenths = roundTrip ? oneWayTenths * 2 : oneWayTenths;
  const rateUnits = Math.max(0, Math.round(ratePerKm * 10000));
  const amount = Math.floor((tenths * rateUnits + 500) / 1000);
  return {oneWayKm: oneWayTenths / 10, totalKm: tenths / 10, amount};
};
